import { Palette } from '@mui/material/styles';
import createPalette from '@mui/material/styles/createPalette';

import { extendedColors } from './extended-colors';
import { v2ExtendedColors } from './v2-extended-colors';

export const v2LightPalette: Palette = createPalette({
  mode: 'light',
  common: {
    black: '#000000',
    white: '#FFFFFF',
  },
  primary: {
    main: '#36707f',
    light: '#5d99a8',
    dark: '#274e58',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#b15e3a',
    light: '#c8855f',
    dark: '#854227',
    contrastText: '#ffffff',
  },
  tertiary: {
    light: '#FB923C',
    main: '#F97316',
    dark: '#EA580C',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#DC2626',
    dark: '#B91C1C',
    light: '#EF4444',
    contrastText: '#FFFFFF',
  },
  warning: {
    light: '#FACC15',
    main: '#EAB308',
    dark: '#CA8A04',
    contrastText: '#000000',
  },
  info: {
    light: '#67E8F9',
    main: '#22D3EE',
    dark: '#06B6D4',
    contrastText: '#000000',
  },
  success: {
    main: '#16A34A',
    dark: '#166534',
    light: '#4ADE80',
    contrastText: '#FFFFFF',
  },
  text: {
    primary: '#171717',
    secondary: '#525252',
    disabled: '#A3A3A3',
  },
  action: {
    active: '#0000008a',
    hover: '#0000000d',
    hoverOpacity: 0.04,
    selected: '#00000015',
    selectedOpacity: 0.08,
    disabled: '#00000042',
    disabledBackground: '#0000001f',
    disabledOpacity: 0.38,
    focus: '#0000001f',
    focusOpacity: 0.12,
    activatedOpacity: 0.12,
  },
  divider: 'rgba(0, 0, 0, 0.15)',
  background: {
    default: '#FAFAFA',
    paper: '#FFFFFF',
  },
  ...extendedColors,
  ...v2ExtendedColors,
});

export const v2DarkPalette: Palette = createPalette({
  mode: 'dark',
  common: {
    black: '#000000',
    white: '#F5F5F5',
  },
  primary: {
    main: '#7eb3c1',
    light: '#a3c9d2',
    dark: '#5d99a8',
    contrastText: '#0f242b',
  },
  secondary: {
    main: '#d09372',
    light: '#e2b095',
    dark: '#a86f4f',
    contrastText: '#2b160c',
  },
  tertiary: {
    light: '#FB923C',
    main: '#F97316',
    dark: '#EA580C',
    contrastText: '#F5F5F5',
  },
  error: {
    main: '#EF4444',
    dark: '#DC2626',
    light: '#F87171',
    contrastText: '#F5F5F5',
  },
  warning: {
    light: '#FACC15',
    main: '#EAB308',
    dark: '#CA8A04',
    contrastText: '#000000',
  },
  info: {
    light: '#67E8F9',
    main: '#22D3EE',
    dark: '#06B6D4',
    contrastText: '#000000',
  },
  success: {
    main: '#22C55E',
    dark: '#16A34A',
    light: '#4ADE80',
    contrastText: '#F5F5F5',
  },
  text: {
    primary: '#F5F5F5',
    secondary: '#D4D4D4',
    disabled: '#737373',
  },
  action: {
    active: '#ffffffde',
    hover: '#ffffff14',
    hoverOpacity: 0.08,
    selected: '#ffffff29',
    selectedOpacity: 0.16,
    disabled: '#ffffff4d',
    disabledBackground: '#ffffff1f',
    disabledOpacity: 0.38,
    focus: '#ffffff1f',
    focusOpacity: 0.12,
    activatedOpacity: 0.24,
  },
  divider: 'rgba(255, 255, 255, 0.2)',
  background: {
    default: '#171717',
    paper: '#262626',
  },
  ...extendedColors,
  ...v2ExtendedColors,
});
